import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Get, Param, Post, Query, Req } from '@nestjs/common';
import { ApiOperation, ApiParam, ApiQuery, ApiTags } from '@nestjs/swagger';
import { AllRoleActivityByUserResponseModel, AllRoleActivityResponseModel, RoleActivityResponseModel } from './dto/role-activity-response.module';
import { RoleActivityDTO ,getroleActivityDTO,getActivityroleDTO} from './dto/role-activity.dto';
import { RoleActivityService } from './role-activity.service';

@ApiTags('RoleActivity')
@Controller('role-activity')
export class RoleActivityController {
    constructor(
        private roleActivityService: RoleActivityService
    ) {}

    
    /* @Get('/getAllRoleActivities')
    async getAllRoleActivities(@Query() queryParams, @Req() request:Request):Promise<AllRoleActivityResponseModel> {
        try {
            return await this.roleActivityService.getAllRoleActivities(queryParams, request);
        } catch (error) {
            return errorHandler(AllRoleActivityResponseModel, error);
        }
    }
 */
    /* @Post('/getActivitiesByRole/:roleId')
    async getActivitiesByRole(@Query() queryParams,@Body()getroleActivityDTO:getroleActivityDTO, @Req() request:Request): Promise<AllRoleActivityResponseModel> {
        try {
            return await this.roleActivityService.getActivitiesByRole(queryParams, getroleActivityDTO, request);
        } catch (error) {
            return errorHandler(AllRoleActivityResponseModel, error);
        }
    } */

    @Get('/getActivitiesByUserId/:userId')
    @ApiOperation({ summary: 'get user name and activities list' })
    @ApiQuery({name:'apiVersion'})
    @ApiParam({name:'userId'})
    async getActivitiesByUserId(@Query() queryParams, @Param('userId') userId,@Req() request:Request): Promise<AllRoleActivityByUserResponseModel> {
        try {
            return await this.roleActivityService.getActivitiesByUserId(queryParams, userId, request);
        } catch (error) {
            return errorHandler(AllRoleActivityByUserResponseModel, error);
        }
    }

    /* @Post('/getActivitiesByActivity/:activityId')
    async getActivitiesByActivity(@Query() queryParams, @Body()getActivityroleDTO:getActivityroleDTO, @Req() request:Request): Promise<AllRoleActivityResponseModel> {
        try {
            return await this.roleActivityService.getActivitiesByActivity(queryParams, getActivityroleDTO, request);
        } catch (error) {
            return errorHandler(AllRoleActivityResponseModel, error);
        }
    } */
}